/**
 * React's `autoFocus`: the control is focused once, when it mounts, and no `autofocus` attribute is
 * rendered. Inside a panel that is still closed the focus does not take, and the dialog then focuses
 * its own first control when it opens, exactly as on the React site.
 */
export function focusOnMount(node: HTMLElement, enabled: boolean | null | undefined): void {
  if (enabled) node.focus();
}
